<template>
    <div class="row px-3 mt-4">
        <!-- Preloading -->
        <placeholder v-if="loading" :type="'table'" :count="3"/>
        <!-- Table -->
        <div class="table-responsive px-1" v-else>
            <AlertMessage 
                :showThen="showThen" 
                @close="showThen.show = false"
            />
            <table class="table bg-white rounder-8 border">
                <thead>
                    <tr>
                        <th class="ellipsis titles-table">Archivo</th>
                        <th class="ellipsis titles-table">Frecuencia</th>
                        <th class="ellipsis titles-table">Acciones</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td class="size-14">
                            Costos y precios
                        </td>
                        <td>
                            <span class="rounder-18 fw-600 size-12 badge class-subiendo" style="width: fit-content">
                                Diario
                            </span>
                        </td>
                        <td>
                            <div class="btn-div">
                                <button 
                                    class="btn btn-success"
                                    @click="selectUpload(0)"
                                >
                                    <img src="/icons/upload-icon-white.svg" alt="icono" class="me-1">
                                    Subir archivos
                                </button>
                                <a href="/static/model_file_pricecost_daily.xlsx" target="_blank">Descargar plantilla</a>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td class="size-14">
                            Costo de reposición 
                        </td>
                        <td>
                            <span class="rounder-18 fw-600 size-12 badge class-subiendo" style="width: fit-content">
                                Diario
                            </span>
                        </td>
                        <td>
                            <div class="btn-div">
                                <button 
                                    class="btn btn-success"
                                    @click="selectUpload(8)"
                                >
                                    <img src="/icons/upload-icon-white.svg" alt="icono" class="me-1">
                                    Subir archivos
                                </button>
                                <a href="/static/model_file_pricecost_daily.xlsx" target="_blank">Descargar plantilla</a>
                            </div>
                        </td>
                    </tr>
                    <tr v-if="(routeView === 'prices-optimization') || (routeView === 'analytics-kpis')" >
                        <td class="size-14">
                            Transacciones de ventas
                        </td>
                        <td>
                            <span class="rounder-18 fw-600 size-12 badge class-subiendo" style="width: fit-content">
                                Diario
                            </span>
                        </td>
                        <td>
                            <div class="btn-div">
                                <button 
                                    class="btn btn-success"
                                    @click="selectUpload(1)"
                                >
                                    <img src="/icons/upload-icon-white.svg" alt="icono" class="me-1">
                                    Subir archivos
                                </button>
                                <a href='/static/model_file_sales.xlsx' target="_blank">Descargar plantilla</a>
                            </div>
                        </td>
                    </tr>
                    <tr
                        v-if="(routeView === 'prices-optimization') || (routeView === 'analytics-kpis')"
                    >
                        <td class="size-14">
                            Stock
                        </td>
                        <td>
                            <span class="rounder-18 fw-600 size-12 badge class-cargado" style="width: fit-content">
                                Semanal
                            </span>
                        </td>
                        <td>
                            <div class="btn-div">
                                <button 
                                    class="btn btn-success"
                                    @click="selectUpload(2)"
                                >
                                <img src="/icons/upload-icon-white.svg" alt="icono" class="me-1">
                                Subir archivos
                                </button>
                                <a href="/static/model_file_stock.xlsx" target="_blank">Descargar plantilla</a>
                            </div>
                        </td>
                    </tr>
                    <tr
                        v-if="(routeView === 'prices-optimization') || (routeView === 'analytics-kpis')"
                    >
                        <td class="size-14">
                            Reposición de producto
                        </td>
                        <td>
                            <span class="rounder-18 fw-600 size-12 badge class-cargado" style="width: fit-content">
                                Semanal
                            </span>
                        </td>
                        <td>
                            <div class="btn-div">
                                <button 
                                    class="btn btn-success"
                                    @click="selectUpload(3)"
                                >
                                <img src="/icons/upload-icon-white.svg" alt="icono" class="me-1">
                                Subir archivos
                                </button>
                                <a href="/static/model_file_reposition.xlsx" target="_blank">Descargar plantilla</a>
                            </div>
                        </td>
                    </tr>
                    <tr
                        v-if="(routeView === 'prices-optimization')"
                    >
                        <td class="size-14">
                            Aceptación y rechazo de optimizaciones
                        </td>
                        <td>
                            <span class="rounder-18 fw-600 size-12 badge class-pendiente" style="width: fit-content">
                                Flexible
                            </span>
                        </td>
                        <td>
                            <div class="btn-div">
                                <button 
                                    class="btn btn-success"
                                    @click="selectUpload(4)"
                                >
                                <img src="/icons/upload-icon-white.svg" alt="icono" class="me-1">
                                Subir archivos
                                </button>
                                <a href="/static/model_recommendation_acept.xlsx" target="_blank">Descargar plantilla</a>
                            </div>
                        </td>
                    </tr>
                    <tr
                        v-if="(routeView === 'analytics-kpis')"
                    >
                        <td class="size-14">
                            Aceptación y rechazo de recomendaciones
                        </td>
                        <td>
                            <span class="rounder-18 fw-600 size-12 badge class-pendiente" style="width: fit-content">
                                Flexible
                            </span>
                        </td>
                        <td>
                            <div class="btn-div">
                                <button 
                                    class="btn btn-success"
                                    @click="selectUpload(5)"
                                >
                                <img src="/icons/upload-icon-white.svg" alt="icono" class="me-1">
                                Subir archivos
                                </button>
                                <a :href="(!authentication_user.client_channel)?'/static/model_micro_recommendation_business_acept.xlsx':'/static/model_micro_recommendation_acept.xlsx'" target="_blank">Descargar plantilla</a>
                            </div>
                        </td>
                    </tr>
                    <tr
                        v-if="(routeView === 'analytics-kpis')"
                    >
                        <td class="size-14">
                            Maestro de ofertas
                        </td>
                        <td>
                            <span class="rounder-18 fw-600 size-12 badge class-pendiente" style="width: fit-content">
                                Flexible
                            </span>
                        </td>
                        <td>
                            <div class="btn-div">
                                <button 
                                    class="btn btn-success"
                                    @click="selectUpload(9)"
                                >
                                <img src="/icons/upload-icon-white.svg" alt="icono" class="me-1">
                                Subir archivos
                                </button>
                                <a href="/static/model_file_offer_master.xlsx" target="_blank">Descargar plantilla</a>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td class="size-14">
                            Creación y actualización de datos y estado de productos
                        </td>
                        <td>
                            <span class="rounder-18 fw-600 size-12 badge class-pendiente" style="width: fit-content">
                                Flexible
                            </span>
                        </td>
                        <td>
                            <div class="btn-div">
                                <button 
                                    class="btn btn-success"
                                    @click="selectUpload(6)"
                                >
                                <img src="/icons/upload-icon-white.svg" alt="icono" class="me-1">
                                Subir archivos
                                </button>
                                <a href="/static/model_file_products.xlsx" target="_blank" >Descargar plantilla</a>
                            </div>
                        </td>
                    </tr>
                    <tr
                        v-if="(routeView === 'competitor-prices')"
                    >
                        <td class="size-14">
                            Precios de la competencia web
                        </td>
                        <td>
                            <span class="rounder-18 fw-600 size-12 badge class-pendiente" style="width: fit-content">
                                Flexible
                            </span>
                        </td>
                        <td>
                            <div class="btn-div">
                                <button 
                                    class="btn btn-success"
                                    @click="selectUpload(7)"
                                >
                                <img src="/icons/upload-icon-white.svg" alt="icono" class="me-1">
                                Subir archivos
                                </button>
                                <a href='/static/model_file_product_scraping_manual.xlsx' target="_blank">Descargar plantilla</a>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td class="size-14">
                            Precios de la competencia en tienda física
                        </td>
                        <td>
                            <span class="rounder-18 fw-600 size-12 badge class-pendiente" style="width: fit-content">
                                Flexible
                            </span>
                        </td>
                        <td>
                            <div class="btn-div">
                                <button 
                                    class="btn btn-success"
                                    @click="selectUpload(10)"
                                >
                                <img src="/icons/upload-icon-white.svg" alt="icono" class="me-1">
                                Subir archivos
                                </button>
                                <a href="/static/model_file_marketplace.xlsx" target="_blank">Descargar plantilla</a>
                            </div>
                        </td>
                    </tr>
                    <tr
                        v-if="(routeView === 'prices-optimization') || (routeView === 'analytics-kpis') || (routeView === 'competitor-prices')"
                    >
                        <td class="size-14">
                            Creación y actualización de políticas del competidor
                        </td>
                        <td>
                            <span class="rounder-18 fw-600 size-12 badge class-pendiente" style="width: fit-content">
                                Flexible
                            </span>
                        </td>
                        <td>
                            <div class="btn-div">
                                <button 
                                    class="btn btn-success"
                                    @click="selectUpload(11)"
                                >
                                <img src="/icons/upload-icon-white.svg" alt="icono" class="me-1">
                                Subir archivos
                                </button>
                                <a href='/static/model_policies_scraping.xlsx' target="_blank">Descargar plantilla</a>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
// List of available upload actions for the table
const data = [
    {name:'Cost',title:'Actualización de costos y precios',description:'Actualiza los costos y precios de tus productos cada vez que sufran alguna variación.'},
    {name:'Transaction',title:'Actualización de transacciones de ventas',description:'Por favor, actualiza los datos de transacciones de ventas de todas las tiendas'},
    {name:'Stock',title:'Actualización de stock',description:'Por favor, actualiza los datos de su stock de cada producto de todas las tiendas'},
    {name:'Reposition',title:'Actualización de reposición',description:'Por favor, actualiza los datos de su reposición de cada producto de todas las tiendas'},
    {name:'Recommendation', title:'Aceptación o rechazo de optimizaciones' , description:'Actualiza las aceptaciones o rechazos de los precios que se ha recomendado el optimizador de precios.'},
    {name:'MicroRecommendation', title:'Aceptación o rechazo de recomendaciones' , description:'Actualiza las aceptaciones o rechazos de los precios que se ha recomendado en el recomendador de precios.'},
    {name:'FormLote',title:'Crear en lote productos',description:''},
    {name:'FormPriceOther',title:' Actualización de precios de la competencia',description:''},
    {name:'CostTwo',title:' Actualización de costo de reposición',description:''},
    {name:'MasterOffer', title:'Maestro de ofertas' , description:'Actualiza el maestro de ofertas de los productos.'},
    {name:'FormPriceStore', title:'Actualización de precios de la competencia en tienda física' , description:''},
    {name:'BatchUpdatePolicy', title:'Actualización de políticas del competidor' , description:'Define las directrices que tus precios deben seguir en comparación con los de tus competidores'}
]
import Placeholder from "../../../../components/loadings/placeholder.vue";
import AlertMessage from '../../../../components/alertMessage.vue'
import { mapGetters } from "vuex";
export default {
    components:{
        Placeholder,
        AlertMessage,
    },
    props: {
        /**
         * Alert message state for showing notifications
         * @type {{show: Boolean, resolve: Boolean, message: String}}
         */
        showThen: {
            type: Object,
            default: () => ({
                show: false,
                resolve: true,
                message: ''
            })
        }
    },
    computed: {
        ...mapGetters([
            "authentication_user",
        ]),
        /**
         * Maps status names to their corresponding CSS classes
         * @returns {Object}
         */
        objectiveClasses() {
            return {
                Pendiente: 'class-pendiente',
                Cargado: 'class-cargado',
                Subiendo: 'class-subiendo',
                Rechazado: 'class-rechazado'
            }
        },
        /**
         * Maps status keys to display names
         * @returns {Object}
         */
        objectiveName() {
            return {
                Pendiente: 'Pendiente',
                Cargado: 'Cargado con éxito',
                Subiendo: 'Subiendo',
                Rechazado: 'Rechazado'
            }
        },
        /**
         * Returns the main route section (used to conditionally render rows)
         * @returns {String}
         */
        routeView() {
            const route = this.$route.path;
            const part = route.split('/').filter(p => p);
            return(part[0])
        }
    },
    data() {
        return {
            loading: true
        }
    },
    created() {
        setTimeout(() => {
            this.loading = false
        }, 1000);
    },
    methods: {
        /**
         * Emits the openUpload event with the selected upload action data
         * @param {Number} option - Index of the action in the data array
         */
        selectUpload(option) {
            this.$emit('openUpload', data[option]);
        }
    }
}
</script>

<style scoped>
    tr{
        height: 52px;
    }
    .titles-table{
        color: #71717A !important;
        font-weight: 600 !important;
    }
    .class-pendiente{
        background-color: #FFF3CD!important;
        color: #CC9A06!important;
    }
    .class-cargado{
        background-color: #D2F4EA!important;
        color: #1AA179!important;
    }
    .class-subiendo{
        background-color: #E3F2FD !important;
        color: #1565C0;
    }
    .class-rechazado{
        background-color: #F8D7DA !important;
        color: #DC3545 !important;
    }
    .btn-success{
        background-color:#1AA179 ;
        padding: 8px 16px !important;
    }
    .btn-success:hover{
        font-weight: 400;
    }   
    a{
        color: #09090B !important;
        text-decoration: underline #09090B !important;
    }
    .btn-div{
        gap: 10px !important;
    }
    .text-link{
        text-decoration: none !important;
        color: white !important;
    }
</style>